import '@tarojs/plugin-platform-h5/dist/runtime'

import { initPxTransform } from '@tarojs/taro'
import { createRouter, createHashHistory, handleAppMount } from '@tarojs/router'
import '@tarojs/components/global.css'
import component from "./app"
import { window } from '@tarojs/runtime'
import { createReactApp } from '@tarojs/plugin-framework-react/dist/runtime'

import * as React from 'react'
import ReactDOM from 'react-dom/client'

import { findDOMNode, render, unstable_batchedUpdates } from 'react-dom'
import { defineCustomElementTaroPullToRefreshCore } from '@tarojs/components/dist/components'


var config = {"router":{},"window":{"backgroundColor":"@backgroundColor","backgroundTextStyle":"@backgroundTextStyle","navigationBarBackgroundColor":"@navigationBarBackgroundColor","navigationBarTitleText":"Taroify","navigationBarTextStyle":"@navigationBarTextStyle","allowsBounceVertical":"NO"},"pages":["pages/home/index","pages/basic/button/index","pages/basic/cell/index","pages/basic/config-provider/index","pages/basic/icon/index","pages/basic/image/index","pages/basic/flex/index","pages/basic/popup/index","pages/basic/style/index","pages/basic/toast/index","pages/basic/space/index","pages/basic/safe-area/index","pages/basic/fixed-view/index","pages/form/cascader/index","pages/form/calendar/index","pages/form/checkbox/index","pages/form/field/index","pages/form/form/index","pages/form/datetime-picker/index","pages/form/number-keyboard/index","pages/form/password-input/index","pages/form/picker/index","pages/form/area-picker/index","pages/form/radio/index","pages/form/rate/index","pages/form/search/index","pages/form/slider/index","pages/form/signature/index","pages/form/stepper/index","pages/form/switch/index","pages/form/uploader/index","pages/action/action-sheet/index","pages/action/dialog/index","pages/action/dropdown-menu/index","pages/action/floating-panel/index","pages/action/floating-bubble/index","pages/action/tour/index","pages/action/loading/index","pages/action/notify/index","pages/action/backdrop/index","pages/action/pull-refresh/index","pages/action/share-sheet/index","pages/action/swipe-cell/index","pages/display/avatar/index","pages/display/badge/index","pages/display/circle/index","pages/display/collapse/index","pages/display/countdown/index","pages/display/divider/index","pages/display/empty/index","pages/display/notice-bar/index","pages/display/list/index","pages/display/progress/index","pages/display/rolling-text/index","pages/display/skeleton/index","pages/display/steps/index","pages/display/sticky/index","pages/display/swiper/index","pages/display/tag/index","pages/display/text-ellipsis/index","pages/display/timeline/index","pages/display/watermark/index","pages/navigation/grid/index","pages/navigation/index-list/index","pages/navigation/navbar/index","pages/navigation/pagination/index","pages/navigation/sidebar/index","pages/navigation/tabs/index","pages/navigation/tabbar/index","pages/navigation/tree-select/index","pages/navigation/back-top/index","pages/navigation/fixed-nav/index","pages/commerce/action-bar/index"],"subpackages":[{"root":"pages/basic","pages":["button/index","cell/index","config-provider/index","icon/index","image/index","flex/index","popup/index","style/index","toast/index","space/index","safe-area/index","fixed-view/index"]},{"root":"pages/form","pages":["cascader/index","calendar/index","checkbox/index","field/index","form/index","datetime-picker/index","number-keyboard/index","password-input/index","picker/index","area-picker/index","radio/index","rate/index","search/index","slider/index","signature/index","stepper/index","switch/index","uploader/index"]},{"root":"pages/action","pages":["action-sheet/index","dialog/index","dropdown-menu/index","floating-panel/index","floating-bubble/index","tour/index","loading/index","notify/index","backdrop/index","pull-refresh/index","share-sheet/index","swipe-cell/index"]},{"root":"pages/display","pages":["avatar/index","badge/index","circle/index","collapse/index","countdown/index","divider/index","empty/index","notice-bar/index","list/index","progress/index","rolling-text/index","skeleton/index","steps/index","sticky/index","swiper/index","tag/index","text-ellipsis/index","timeline/index","watermark/index"]},{"root":"pages/navigation","pages":["grid/index","index-list/index","navbar/index","pagination/index","sidebar/index","tabs/index","tabbar/index","tree-select/index","back-top/index","fixed-nav/index"]},{"root":"pages/commerce","pages":["action-bar/index"]}],"subPackages":[{"root":"pages/basic","pages":["button/index","cell/index","config-provider/index","icon/index","image/index","flex/index","popup/index","style/index","toast/index","space/index","safe-area/index","fixed-view/index"]},{"root":"pages/form","pages":["cascader/index","calendar/index","checkbox/index","field/index","form/index","datetime-picker/index","number-keyboard/index","password-input/index","picker/index","area-picker/index","radio/index","rate/index","search/index","slider/index","signature/index","stepper/index","switch/index","uploader/index"]},{"root":"pages/action","pages":["action-sheet/index","dialog/index","dropdown-menu/index","floating-panel/index","floating-bubble/index","tour/index","loading/index","notify/index","backdrop/index","pull-refresh/index","share-sheet/index","swipe-cell/index"]},{"root":"pages/display","pages":["avatar/index","badge/index","circle/index","collapse/index","countdown/index","divider/index","empty/index","notice-bar/index","list/index","progress/index","rolling-text/index","skeleton/index","steps/index","sticky/index","swiper/index","tag/index","text-ellipsis/index","timeline/index","watermark/index"]},{"root":"pages/navigation","pages":["grid/index","index-list/index","navbar/index","pagination/index","sidebar/index","tabs/index","tabbar/index","tree-select/index","back-top/index","fixed-nav/index"]},{"root":"pages/commerce","pages":["action-bar/index"]}],"animation":false,"darkmode":true,"themeLocation":"theme.json"}
window.__taroAppConfig = config

if (config.tabBar) {
  var tabbarList = config.tabBar.list
  for (var i = 0; i < tabbarList.length; i++) {
    var t = tabbarList[i]
    if (t.iconPath) {
      t.iconPath = tabbarIconPath[i]
    }
    if (t.selectedIconPath) {
      t.selectedIconPath = tabbarSelectedIconPath[i]
    }
  }
}
config.routes = [
  Object.assign({
  path: 'pages/home/index',
  load: function(context, params) {
    const page = import("./pages/home/index")
    return [page, context, params]
  }
}, {"enableShareAppMessage":true,"navigationBarTitleText":"首页"}),Object.assign({
  path: 'pages/basic/button/index',
  load: function(context, params) {
    const page = import("./pages/basic/button/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Button 按钮"}),Object.assign({
  path: 'pages/basic/cell/index',
  load: function(context, params) {
    const page = import("./pages/basic/cell/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Cell 单元格"}),Object.assign({
  path: 'pages/basic/config-provider/index',
  load: function(context, params) {
    const page = import("./pages/basic/config-provider/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"ConfigProvider 全局配置"}),Object.assign({
  path: 'pages/basic/icon/index',
  load: function(context, params) {
    const page = import("./pages/basic/icon/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Icon 图标"}),Object.assign({
  path: 'pages/basic/image/index',
  load: function(context, params) {
    const page = import("./pages/basic/image/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Image 图片"}),Object.assign({
  path: 'pages/basic/flex/index',
  load: function(context, params) {
    const page = import("./pages/basic/flex/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Flex 布局"}),Object.assign({
  path: 'pages/basic/popup/index',
  load: function(context, params) {
    const page = import("./pages/basic/popup/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Popup 弹出层"}),Object.assign({
  path: 'pages/basic/style/index',
  load: function(context, params) {
    const page = import("./pages/basic/style/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"内置样式"}),Object.assign({
  path: 'pages/basic/toast/index',
  load: function(context, params) {
    const page = import("./pages/basic/toast/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Toast 轻提示"}),Object.assign({
  path: 'pages/basic/space/index',
  load: function(context, params) {
    const page = import("./pages/basic/space/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Space 间距"}),Object.assign({
  path: 'pages/basic/safe-area/index',
  load: function(context, params) {
    const page = import("./pages/basic/safe-area/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"SafeArea 安全区域"}),Object.assign({
  path: 'pages/basic/fixed-view/index',
  load: function(context, params) {
    const page = import("./pages/basic/fixed-view/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"FixedView 固定视图"}),Object.assign({
  path: 'pages/form/cascader/index',
  load: function(context, params) {
    const page = import("./pages/form/cascader/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Cascader 级联选择"}),Object.assign({
  path: 'pages/form/calendar/index',
  load: function(context, params) {
    const page = import("./pages/form/calendar/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Calendar 日历"}),Object.assign({
  path: 'pages/form/checkbox/index',
  load: function(context, params) {
    const page = import("./pages/form/checkbox/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Checkbox 复选框"}),Object.assign({
  path: 'pages/form/field/index',
  load: function(context, params) {
    const page = import("./pages/form/field/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Field 输入框"}),Object.assign({
  path: 'pages/form/form/index',
  load: function(context, params) {
    const page = import("./pages/form/form/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Form 表单"}),Object.assign({
  path: 'pages/form/datetime-picker/index',
  load: function(context, params) {
    const page = import("./pages/form/datetime-picker/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"DatetimePicker 时间选择"}),Object.assign({
  path: 'pages/form/number-keyboard/index',
  load: function(context, params) {
    const page = import("./pages/form/number-keyboard/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"NumberKeyboard 数字键盘"}),Object.assign({
  path: 'pages/form/password-input/index',
  load: function(context, params) {
    const page = import("./pages/form/password-input/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"PasswordInput 密码输入框"}),Object.assign({
  path: 'pages/form/picker/index',
  load: function(context, params) {
    const page = import("./pages/form/picker/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Picker 选择器"}),Object.assign({
  path: 'pages/form/area-picker/index',
  load: function(context, params) {
    const page = import("./pages/form/area-picker/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"AreaPicker 省市区选择器"}),Object.assign({
  path: 'pages/form/radio/index',
  load: function(context, params) {
    const page = import("./pages/form/radio/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Radio 单选框"}),Object.assign({
  path: 'pages/form/rate/index',
  load: function(context, params) {
    const page = import("./pages/form/rate/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Rate 评分"}),Object.assign({
  path: 'pages/form/search/index',
  load: function(context, params) {
    const page = import("./pages/form/search/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Search 搜索"}),Object.assign({
  path: 'pages/form/slider/index',
  load: function(context, params) {
    const page = import("./pages/form/slider/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Slider 滑块"}),Object.assign({
  path: 'pages/form/signature/index',
  load: function(context, params) {
    const page = import("./pages/form/signature/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Signature 签名"}),Object.assign({
  path: 'pages/form/stepper/index',
  load: function(context, params) {
    const page = import("./pages/form/stepper/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Stepper 步进器"}),Object.assign({
  path: 'pages/form/switch/index',
  load: function(context, params) {
    const page = import("./pages/form/switch/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Switch 开关"}),Object.assign({
  path: 'pages/form/uploader/index',
  load: function(context, params) {
    const page = import("./pages/form/uploader/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Uploader 文件上传"}),Object.assign({
  path: 'pages/action/action-sheet/index',
  load: function(context, params) {
    const page = import("./pages/action/action-sheet/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"ActionSheet 动作面板"}),Object.assign({
  path: 'pages/action/dialog/index',
  load: function(context, params) {
    const page = import("./pages/action/dialog/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Dialog 弹出框"}),Object.assign({
  path: 'pages/action/dropdown-menu/index',
  load: function(context, params) {
    const page = import("./pages/action/dropdown-menu/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"DropdownMenu 下拉菜单","enablePageMeta":true}),Object.assign({
  path: 'pages/action/floating-panel/index',
  load: function(context, params) {
    const page = import("./pages/action/floating-panel/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"FloatingPanel 浮动面板"}),Object.assign({
  path: 'pages/action/floating-bubble/index',
  load: function(context, params) {
    const page = import("./pages/action/floating-bubble/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"FloatingBubble 浮动气泡"}),Object.assign({
  path: 'pages/action/tour/index',
  load: function(context, params) {
    const page = import("./pages/action/tour/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Tour 引导"}),Object.assign({
  path: 'pages/action/loading/index',
  load: function(context, params) {
    const page = import("./pages/action/loading/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Loading 加载"}),Object.assign({
  path: 'pages/action/notify/index',
  load: function(context, params) {
    const page = import("./pages/action/notify/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Notify 消息提示"}),Object.assign({
  path: 'pages/action/backdrop/index',
  load: function(context, params) {
    const page = import("./pages/action/backdrop/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Backdrop 背景暗化"}),Object.assign({
  path: 'pages/action/pull-refresh/index',
  load: function(context, params) {
    const page = import("./pages/action/pull-refresh/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"PullRefresh 下拉刷新","disableScroll":true}),Object.assign({
  path: 'pages/action/share-sheet/index',
  load: function(context, params) {
    const page = import("./pages/action/share-sheet/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"ShareSheet 分享面板"}),Object.assign({
  path: 'pages/action/swipe-cell/index',
  load: function(context, params) {
    const page = import("./pages/action/swipe-cell/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"SwipeCell 滑动单元格"}),Object.assign({
  path: 'pages/display/avatar/index',
  load: function(context, params) {
    const page = import("./pages/display/avatar/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Avatar 头像"}),Object.assign({
  path: 'pages/display/badge/index',
  load: function(context, params) {
    const page = import("./pages/display/badge/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Badge 徽标"}),Object.assign({
  path: 'pages/display/circle/index',
  load: function(context, params) {
    const page = import("./pages/display/circle/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Circle 环形进度条"}),Object.assign({
  path: 'pages/display/collapse/index',
  load: function(context, params) {
    const page = import("./pages/display/collapse/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Collapse 折叠面板"}),Object.assign({
  path: 'pages/display/countdown/index',
  load: function(context, params) {
    const page = import("./pages/display/countdown/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Countdown 倒计时"}),Object.assign({
  path: 'pages/display/divider/index',
  load: function(context, params) {
    const page = import("./pages/display/divider/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Divider 分割线"}),Object.assign({
  path: 'pages/display/empty/index',
  load: function(context, params) {
    const page = import("./pages/display/empty/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Empty 空状态"}),Object.assign({
  path: 'pages/display/notice-bar/index',
  load: function(context, params) {
    const page = import("./pages/display/notice-bar/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"NoticeBar 通知栏"}),Object.assign({
  path: 'pages/display/list/index',
  load: function(context, params) {
    const page = import("./pages/display/list/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"List 列表"}),Object.assign({
  path: 'pages/display/progress/index',
  load: function(context, params) {
    const page = import("./pages/display/progress/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Progress 进度条"}),Object.assign({
  path: 'pages/display/rolling-text/index',
  load: function(context, params) {
    const page = import("./pages/display/rolling-text/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"RollingText 翻滚文本动效"}),Object.assign({
  path: 'pages/display/skeleton/index',
  load: function(context, params) {
    const page = import("./pages/display/skeleton/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Skeleton 骨架屏"}),Object.assign({
  path: 'pages/display/steps/index',
  load: function(context, params) {
    const page = import("./pages/display/steps/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Steps 步骤条"}),Object.assign({
  path: 'pages/display/sticky/index',
  load: function(context, params) {
    const page = import("./pages/display/sticky/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Sticky 粘性布局"}),Object.assign({
  path: 'pages/display/swiper/index',
  load: function(context, params) {
    const page = import("./pages/display/swiper/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Swiper 轮播"}),Object.assign({
  path: 'pages/display/tag/index',
  load: function(context, params) {
    const page = import("./pages/display/tag/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Tag 标签"}),Object.assign({
  path: 'pages/display/text-ellipsis/index',
  load: function(context, params) {
    const page = import("./pages/display/text-ellipsis/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"TextEllipsis 文本省略"}),Object.assign({
  path: 'pages/display/timeline/index',
  load: function(context, params) {
    const page = import("./pages/display/timeline/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Timeline 时间轴"}),Object.assign({
  path: 'pages/display/watermark/index',
  load: function(context, params) {
    const page = import("./pages/display/watermark/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Watermark 水印"}),Object.assign({
  path: 'pages/navigation/grid/index',
  load: function(context, params) {
    const page = import("./pages/navigation/grid/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Grid 宫格"}),Object.assign({
  path: 'pages/navigation/index-list/index',
  load: function(context, params) {
    const page = import("./pages/navigation/index-list/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"IndexList 索引栏"}),Object.assign({
  path: 'pages/navigation/navbar/index',
  load: function(context, params) {
    const page = import("./pages/navigation/navbar/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Navbar 导航栏"}),Object.assign({
  path: 'pages/navigation/pagination/index',
  load: function(context, params) {
    const page = import("./pages/navigation/pagination/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Pagination 分页"}),Object.assign({
  path: 'pages/navigation/sidebar/index',
  load: function(context, params) {
    const page = import("./pages/navigation/sidebar/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Sidebar 侧边导航"}),Object.assign({
  path: 'pages/navigation/tabs/index',
  load: function(context, params) {
    const page = import("./pages/navigation/tabs/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Tabs 标签页"}),Object.assign({
  path: 'pages/navigation/tabbar/index',
  load: function(context, params) {
    const page = import("./pages/navigation/tabbar/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"Tabbar 标签栏"}),Object.assign({
  path: 'pages/navigation/tree-select/index',
  load: function(context, params) {
    const page = import("./pages/navigation/tree-select/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"TreeSelect 分类选择"}),Object.assign({
  path: 'pages/navigation/back-top/index',
  load: function(context, params) {
    const page = import("./pages/navigation/back-top/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"BackTop 回到顶部"}),Object.assign({
  path: 'pages/navigation/fixed-nav/index',
  load: function(context, params) {
    const page = import("./pages/navigation/fixed-nav/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"FixedNav 悬浮导航"}),Object.assign({
  path: 'pages/commerce/action-bar/index',
  load: function(context, params) {
    const page = import("./pages/commerce/action-bar/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"ActionBar 动作栏"})
]
Object.assign(ReactDOM, { findDOMNode, render, unstable_batchedUpdates })
defineCustomElementTaroPullToRefreshCore()

var inst = createReactApp(component, React, ReactDOM, config)
var history = createHashHistory({ window })
handleAppMount(config, history)
createRouter(history, inst, config, React)
initPxTransform({
  designWidth: 750,
  deviceRatio: {"640":1.17,"750":1,"828":0.905},
  baseFontSize: 20,
  unitPrecision: undefined,
  targetUnit: undefined
})
